import { Model } from "@bryntum/schedulerpro";
import { HasProjectMixin } from "./mixins/HasProjectMixin";

export class MarketingPage extends HasProjectMixin(Model) {

  declare id: number;
  declare board: number;
  declare workFile: number | null;
  declare slug: string;
  declare title: string;
  declare url: string;
  declare includeInSite: boolean;
  declare metaTitle: string;
  declare metaDescription: string;
  declare canonicalUrl: string;
  declare robotsIndex: boolean;
  declare robotsFollow: boolean;
  declare ogTitle: string;
  declare ogDescription: string;
  /** Read-only via Bryntum sync — use OG image upload endpoint to change. */
  declare ogImageUrl: string;
  /** Read-only via Bryntum sync — set by OG image upload endpoint. */
  declare ogImageThumbnailUrl: string;
  declare twitterCard: string;
  declare createdAt: Date;
  declare updatedAt: Date;
  declare creator: number | null;
  declare updater: number | null;

  static get $name() {
    return "MarketingPage";
  }

  static get fields() {
    return [
      "id",
      "board",
      { name: "workFile", dataSource: "work_file", type: "number" },
      "slug",
      "title",
      "url",
      { name: "includeInSite", dataSource: "include_in_site", type: "boolean", defaultValue: false },
      { name: "metaTitle", dataSource: "meta_title" },
      { name: "metaDescription", dataSource: "meta_description" },
      { name: "canonicalUrl", dataSource: "canonical_url" },
      { name: "robotsIndex", dataSource: "robots_index", type: "boolean", defaultValue: true },
      { name: "robotsFollow", dataSource: "robots_follow", type: "boolean", defaultValue: true },
      { name: "ogTitle", dataSource: "og_title" },
      { name: "ogDescription", dataSource: "og_description" },
      { name: "ogImageUrl", dataSource: "og_image_url" },
      { name: "ogImageThumbnailUrl", dataSource: "og_image_thumbnail_url" },
      { name: "twitterCard", dataSource: "twitter_card", defaultValue: "summary_large_image" },
      { name: "createdAt", dataSource: "created_at", type: "date" },
      { name: "updatedAt", dataSource: "updated_at", type: "date" },
      { name: "creator", type: "number" },
      { name: "updater", type: "number" },
    ];
  }
}

// @ts-expect-error - exposeProperties is internal method
MarketingPage.exposeProperties();
